import HeadingWithNubbon from "../components/HeadingWithNubbon";
import EventList from "../components/EventList";
// import { projects } from "../assets/content/projects";
import { useProjects } from "../features/projects/useProjects";

function Tours() {
    const { isLoading, projects } = useProjects();
    return (
        <section
            className="tours main-section"
            id="tours"
        >
            <HeadingWithNubbon text={"Tourdata"} />
            {!isLoading && <EventList projects={projects} />}
        </section>
    );
}

export default Tours;
